import React from "react"
import { Application } from "@theguarantors/ui-kit-v2/dist/layout/one-column-form"
import { FormStep, ValidationProvider } from "@theguarantors/ui-kit-v2"
import { UnenrolledForm } from "./UnenrolledPage.form"
import { Formik } from "formik"
import { validationSchema } from "./UnenrolledPage.validation"
import { Props, UnenrolledFormValues } from "./UnenrolledPage.types"
import { defaultMenuItems, menuItemsForNoApartment } from "../../constants/menu"
import { FeatureFlag, useFeatureFlag } from "../../hooks/use-feature-flag"
import { HeaderV2 } from "@theguarantors/ui-kit-v2/dist/layout/HeaderV2"
import { Footer } from "@theguarantors/ui-kit-v2/dist/layout/one-column-form/Footer"
import { Content } from "@theguarantors/ui-kit-v2/dist/layout/one-column-form/Content"
import { useLocation } from "react-router-dom"

const staticInitialValues: Omit<UnenrolledFormValues, "apartmentNumber" | "addressStreet"> = {
  email: "",
  brokerEmail: "",
  brokerName: "",
  addressCity: "",
  addressState: "",
  zipCode: "",
  landlordCompany: "",
  annualIncome: "",
  liquidAsset: "",
  landlordEmail: "",
  landlordName: "",
}

export const UnenrolledPageComponent: React.FC<Props> = ({ onSubmit }) => {
  const location = useLocation()
  const [rebrandV2MonolithReact] = useFeatureFlag(FeatureFlag.REBRAND_V2_MONOLITH_REACT)
  const rebrandV2MonolithReactFeatureFlag: Boolean = rebrandV2MonolithReact === "on"

  const initialValues: UnenrolledFormValues = React.useMemo(
    () => ({
      ...staticInitialValues,
      apartmentNumber: location?.state?.unit ?? "",
      addressStreet: location?.state?.address ?? "",
    }),
    [location]
  )

  const UnenrolledPageForm = () => (
    <FormStep.Wrapper>
      <FormStep.Title data-testid="headline">Get Qualified.</FormStep.Title>
      <FormStep.Subtitle as="p" mt="0" data-testid="subheadline">
        The building you entered may not be registered with TheGuarantors. Creating an account will allow you to login
        and apply if your building is approved.
      </FormStep.Subtitle>
      <ValidationProvider value={validationSchema}>
        <Formik
          initialValues={initialValues}
          validateOnBlur={false}
          validateOnChange={false}
          onSubmit={onSubmit}
          component={UnenrolledForm as any}
        />
      </ValidationProvider>
    </FormStep.Wrapper>
  )

  const NewHeader = () => (
    <>
      <HeaderV2 couper={[<></>, <></>]} menuItems={menuItemsForNoApartment} />
      <Content data-testid={"test-data"}>
        <UnenrolledPageForm />
      </Content>
      <Footer />
    </>
  )

  return rebrandV2MonolithReactFeatureFlag ? (
    <NewHeader />
  ) : (
    <Application headerMenuItems={defaultMenuItems}>
      {" "}
      <UnenrolledPageForm />
    </Application>
  )
}
